// Regular expression to check if string matches 'asset/UUID' format.
export const ASSET_ID_REGEX = /^asset\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
